export const LIMIT_DAYS_TO_REVIEW = 56;
//# sourceMappingURL=constants.js.map